import styled from 'styled-components';

export const StyledSignupPageWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
